jQuery( window ).on( 'load', function( $ ) {

	/**
	 * Grabs gallery button & gallery div for some sweet animation action. Then,
	 * the button is animated into place with the two following functions below:
	 * showEditToolbars() & hideEditToolbars() -- 12.13.16 - JD
	 */
	var $gallery = document.querySelector('#gallery');
	var $mobileGalleryButton = document.querySelector('.editor-functions-toolbar__mobile__options .gallery__button');
	// var $xButton = document.querySelector('#gallery-close-mobile');
	// var $desktopGalleryButton = document.querySelector('#gallery-open-desktop');
	/**
	 * I phenagled a gallery button to fit into the existing mobile menu. Maybe
	 * I should have stored all elements with the 'gallery__button' class in a
	 * single nodelist var but I wasn't exactly sure how to manipulate them
	 * individually if I had.
	 */
	// $xButton.classList.add("close"); // animates hamburger button

	$mobileGalleryButton.addEventListener('click', function() {
		$gallery.classList.toggle('hidden');
		hideFunctionsToolbarMobile();
	});

/* 	$xButton.addEventListener('click', function() {
		// $gallery.classList.toggle('hidden');     // this is already being done in snowman.js
		if(window.innerWidth > 1023) {
			showEditToolbars();
		}
	}) */

/* 	$desktopGalleryButton.addEventListener('click', function() {
		$gallery.classList.toggle('hidden');        // this is already being done in snowman.js
	});
 */
	/* Display/hide helper functions */

	/**
	 * Shows manipulation toolbar, object toolbar, and object category toolbar.
	 *
	 * Also removes 'hide' class from elements that might have had it added in
	 * mobile. Those do not mirror hideEditToolbars() exactly.
	 */
	function showEditToolbars() {
		jQuery(".object-manipulation-toolbar__options").removeClass("hide");  // Manipulation toolbar
		jQuery("#menu, .object-toolbar").removeClass("hide-desktop").removeClass("hide");  // Object toolbar
		jQuery("#ui__object-category-toolbar__buttons, .object-category-toolbar").removeClass("hide");  // Object category toolbar
		jQuery(".object-manipulation-toolbar__branding__logo").removeClass("hide");  // Show logo (if hidden)
		jQuery(".social-media-toolbar").addClass("hide");
		jQuery("#share-url").addClass("hide");
		jQuery("#ui__build-toolbar__buttons").addClass("hide");
		jQuery(".snowman-preview-save-share-toolbar__options").removeClass("hide");
		jQuery(".save-status-toolbar, .save-status").addClass("hide");
		jQuery(".gallery__button").addClass('slide');
	}

	/**
	 * Hides manipulation toolbar, object toolbar, and object category toolbar.
	 */
	function hideEditToolbars() {
		jQuery(".object-manipulation-toolbar__options").addClass("hide");  // Manipulation toolbar
		jQuery("#menu").addClass("hide-desktop").addClass("hide");  // Object toolbar
		jQuery("#ui__object-category-toolbar__buttons").addClass("hide");  // Object category toolbar
		jQuery(".snowman-preview-save-share-toolbar__options").addClass("hide");  // preview/save/share toolbar
		jQuery(".gallery__button").removeClass('slide');
	}

	/**
	 * Shows main preview/save/share functions
	 * (hides secondary buttons on toolbar)
	 */
	function showFunctionsToolbar() {
		jQuery(".snowman-preview-save-share-toolbar__options").addClass("hide");
		jQuery("#ui__editor-functions-toolbar__buttons, .object-category-toolbar").removeClass("hide");
        jQuery("image-controls").removeClass("active");
	}

	/**
	 * Hides main preview/save/share functions
	 * (shows secondary buttons on toolbar)
	 */
	function hideFunctionsToolbar() {
		jQuery(".snowman-preview-save-share-toolbar__options").removeClass("hide");
		jQuery("#ui__editor-functions-toolbar__buttons").addClass("hide");
		jQuery(".social-media-toolbar").addClass("hide");
		jQuery("#share-url").addClass("hide");
		jQuery(".save-status-toolbar, .save-status").addClass("hide");
	}

	/**
	 * Shows main preview/save/share functions for *mobile*
	 * (shows secondary buttons on toolbar)
	 */
	function showFunctionsToolbarMobile() {
		jQuery(".menu-toggle").addClass("close"); // animates hamburger button
        jQuery("#gallery-toggle").addClass("close");
		// jQuery(".menu__container__mobile").addClass("show");

		// jQuery(".scenery__container__foreground__mountains").addClass("menu-view");

		jQuery(".editor-functions-toolbar__mobile__options__wrapper").addClass("menu-view");
		jQuery(".editor-functions-toolbar__mobile__option").addClass("menu-view");
        jQuery('#image-controls').removeClass("active");
        jQuery(".right").addClass("hide");
	}

	/**
	 * Hides main preview/save/share functions for *mobile*
	 * (hides secondary buttons on toolbar)
	 */
	function hideFunctionsToolbarMobile() {
		jQuery(".menu-toggle").removeClass("close"); // animates hamburger button
		jQuery("#gallery-toggle").removeClass("close"); 

		// jQuery(".menu__container__mobile").removeClass("show");

		// jQuery(".scenery__container__foreground__mountains").removeClass("menu-view");

		jQuery(".editor-functions-toolbar__mobile__options__wrapper").removeClass("menu-view");
		jQuery(".editor-functions-toolbar__mobile__option").removeClass("menu-view");
        jQuery('#image-controls').addClass("active");
        jQuery(".right").removeClass("hide");
	}



	/* Click Event Handlers */
	// TODO: The mobile parts could probably be cleaner

	// Click event for *mobile* hamburger icon
	jQuery(".menu-toggle").on('click tap', function() {
		if ( jQuery(".menu-toggle").hasClass("close") ) {
			// Show edit Toolbar
			showEditToolbars();

			// Close the menu
			hideFunctionsToolbarMobile();
			hideFunctionsToolbar();

			jQuery(".scenery__container__foreground__stage").removeClass("hide"); // Shows the stage
			jQuery(".social-media-toolbar").addClass("hide");  // Hide potentially visible social icons
			jQuery("#share-url").addClass("hide");

		} else {
			// Hide edit Toolbar
			hideEditToolbars();
			jQuery(".object-toolbar, .object-category-toolbar").addClass("hide");  // Hide both toolbars entirely in mobile
			jQuery(".object-manipulation-toolbar__branding__logo").addClass("hide");  // Hide logo in mobile menu

			// Open the menu
			showFunctionsToolbarMobile();

			jQuery(".scenery__container__foreground__stage").addClass("hide"); // Hides the stage
			jQuery(".social-media-toolbar").addClass("hide");  // Hide potentially visible social icons
			jQuery("#share-url").addClass("hide");
		}
	});
    
	jQuery("#gallery-toggle").on('click tap', function() {
        jQuery("#gallery").addClass("hidden");
        /* 
        if ( jQuery(".welcome").hasClass("active") ) {
            jQuery(".welcome").removeClass("active");
            jQuery(".left").css("background-color", "#FFF8E2").css("min-height", "auto");
            jQuery(".right").css("display", "flex");
            jQuery("")
        } */
        
		if ( jQuery("#gallery-toggle").hasClass("close") ) {
			// Show edit Toolbar
			showEditToolbars();

			// Close the menu
			hideFunctionsToolbarMobile();
			hideFunctionsToolbar();

			jQuery(".scenery__container__foreground__stage").removeClass("hide"); // Shows the stage
			jQuery(".social-media-toolbar").addClass("hide");  // Hide potentially visible social icons
			jQuery("#share-url").addClass("hide");

		} else {
			// Hide edit Toolbar
			hideEditToolbars();
			jQuery(".object-toolbar, .object-category-toolbar").addClass("hide");  // Hide both toolbars entirely in mobile
			jQuery(".object-manipulation-toolbar__branding__logo").addClass("hide");  // Hide logo in mobile menu

			// Open the menu
			showFunctionsToolbarMobile();

			jQuery(".scenery__container__foreground__stage").addClass("hide"); // Hides the stage
			jQuery(".social-media-toolbar").addClass("hide");  // Hide potentially visible social icons
			jQuery("#share-url").addClass("hide");
		}
	});

	// Click handler for preview/save/share on edit toolbar
	// Puts stage in preview mode
	jQuery(".preview-button, .share-button").on('click tap', function() {
		loadState( 'preview' );
	});

	// Click handler for preview/save/share on *mobile* edit toolbar
	// Puts stage in preview mode
	jQuery(".preview-button-mobile, .save-button-mobile, .share-button-mobile").on('click tap', function() {
		hideFunctionsToolbarMobile();
		jQuery(".scenery__container__foreground__stage").removeClass("hide"); // show the stage

		jQuery(".save-status-toolbar, .save-status").addClass("hide");

		loadState( 'preview' );
	});
    
	// Perform the actual save when initially clicking save
	jQuery(".save-button, .save-button-mobile").on('click tap', function() {
		document.stage.save();
		jQuery(".social-media-toolbar").addClass("hide");
        console.log('shareurl: ' + jQuery("#share-url"));
		// jQuery("#share-url").addClass("hide");
		jQuery(".save-status-toolbar, .save-status").removeClass("hide");
		setTimeout( function() {
			jQuery(".save-status-toolbar, .save-status").addClass("hide");
		}, 10000);
	});

	// Click handler for build button on functions toolbar
	jQuery(".build-button").on('click tap', function() {
		// Clear the stage and create a new snowman
		document.stage.clear();
		app.user = null;
		loadState( 'edit' );
	});


	// Click handler for edit button(s)
	jQuery(".edit-button").on('click tap', function() {
		loadState( 'edit' );
	});

	// Click handler for share button on functions toolbar
	jQuery("#share-button, .editor-functions-toolbar__mobile__option.share-button-mobile").on('click tap', function() {
		if ( ! app.user ) { document.stage.save(); }
		jQuery(".save-status-toolbar, .save-status").addClass("hide");
		jQuery(".social-media-toolbar").toggleClass("hide");
		jQuery("#share-url").toggleClass("hide");
		createSocialLinks();
	});

	// Show share buttons when clicking share from desktop, but delay to finish preview animation
	jQuery(".snowman-preview-save-share-toolbar__option.share-button").on('click tap', function() {
		if ( ! app.user ) { document.stage.save(); }
		jQuery(".save-status-toolbar, .save-status").addClass("hide");

		setTimeout( function() {
			jQuery(".social-media-toolbar").toggleClass("hide");
			jQuery("#share-url").toggleClass("hide");
			createSocialLinks();
		}, 1000);
	});

	/**
	 * Updates the social links with current snowman url.
	 */
	function createSocialLinks() {
		var url = 'https:' + ( document.stage.url.card || app.siteurl );
		var snowman_url = encodeURIComponent( url );
		var base_url = encodeURIComponent( app.siteurl );

		var subject = encodeURIComponent( 'Happy Holidays!' );
		var body_text = encodeURIComponent( 'Happy Holidays from me and my snowman! ' ) + snowman_url;
		var hashtag = encodeURIComponent( ' #buildyoursnowman' );

		var facebook_url = 'https://www.facebook.com/sharer/sharer.php?u=' + snowman_url;
		var twitter_url = 'https://twitter.com/home?status=' + body_text + hashtag;
		var email_url = 'mailto:?' +
			'subject=' + subject +
			'&body=' + body_text;
		var pinterest_url = 'https://www.pinterest.com/pin/create/button/?' +
			'url=' + base_url +
			'&media=' + snowman_url +
			'description=' + body_text;

		jQuery( '#share-facebook' ).attr( 'href', facebook_url );
		jQuery( '#share-twitter' ).attr( 'href', twitter_url );
		jQuery( '#share-pinterest' ).attr( 'href', pinterest_url );
		jQuery( '#share-email' ).attr( 'href', email_url );
		jQuery( '#share-url' ).text( 'Hold on just a second! Saving snowman...' );
	}

	/**
	 * Hides the intro animation and mountain animation
	 */
	function hideIntro() {
		jQuery('body')
			.addClass('loaded')
			.removeClass('unloaded')
			.removeClass('intro');
		jQuery('#main-intro')
			.removeClass('open')
			.hide();
	}


	/**
	 * Hides the mountains instantly without the animation.
	 */
	function hideMountains() {
		jQuery('body')
			.removeClass( 'intro' )
			.removeClass('loaded')
			.addClass('unloaded');
	}

	/**
	 * Hides the mountains with the animation.
	 */
	function hideMountainsAnimation() {
		jQuery('body')
			.addClass( 'intro' )
			.removeClass('loaded')
			.addClass('unloaded');
	}

	/**
	 * Shows the mountains with the animation.
	 */
	function showMountainAnimation() {
		jQuery('body')
			.addClass( 'intro' )
			.addClass('loaded')
			.removeClass('unloaded');
	}

	/**
	 * Shows the intro animation
	 *
	 * @param function - an optional function that is run after the intro is
	 * 					 done.
	 */
	function showIntro( fn ) {
		// Don't annoy people:
		if ( getCookie( 'intro' ) === 'hide' ) {
            // Hide intro
			jQuery('#main-intro').removeClass('open').hide();

			// Show mountain animation
			jQuery('body').addClass('loaded').removeClass('unloaded');

			return (fn) ? fn() : null;
		}

		jQuery('body').removeClass('loaded').addClass('unloaded');
		jQuery('body').addClass('intro');
		jQuery('#main-intro').addClass('open').show();
		jQuery('#main-intro .modal-slider').addClass('animated');

		// Initialize slick on intro
/* 		jQuery('.modal-slider').slick({
		  dots: true,
		  speed: 300,
		  autoplay: false,
		  arrows: false,
		  infinite: false,
		  slidesToShow: 1,
		  adaptiveHeight: false
		}); */

		// Next button click handler
		jQuery('.button__next').on('click tap', function( event ) {
			event.preventDefault();
			jQuery('.modal-slider').slick("slickNext");
		});

		// Intro close button click handler
		jQuery('.modal-slider .button__close').click( function(){
			jQuery(this).closest('.modal').removeClass('animated').hide();
			jQuery('#main-intro').removeClass('open');
			jQuery('body').addClass('loaded').removeClass('unloaded');
			setTimeout(function(){
				jQuery('body').removeClass('intro');
				setCookie( 'intro', 'hide', .08 );  // Don't show for 2 hours
			}, 5000);
			return (fn) ? fn() : null;
		});

	}


    /* Northern Lights */

	nl1 = null;

    /**
     * Sets the northern lights to the state of on argument.
     */
	document.setNorthernLights = function setNorthernLights( on ) {
		return ( on ) ? turnNorthernLightsOn() : turnNorthernLightsOff();
	}

    /**
     * Does the actual work of turning the lights on.
     */
	function turnNorthernLightsOn() {
		document.stage.northern_lights = true;
		jQuery( '#northern-lights' ).parent().addClass( 'on' );
		nighttime();
		if( nl1 ) {
			nl1.start();
			document.querySelector( '.lightsContainer' ).appendChild( NorthernLightsDiv );
			// new NorthernLights (document.body, null, null, curves);
		} else {
			nl1 = new NorthernLights ( document.body, null, null, curves );
		}
	}

    /**
     * Does the actual work of turning the lights off.
     */
	function turnNorthernLightsOff() {
		document.stage.northern_lights = false;
		jQuery( '#northern-lights' ).parent().removeClass( 'on' );
		if ( nl1 ) { nl1.pause(); }
		jQuery( '.lightsContainer canvas' ).remove();
	}

    // Event handler for northern lights menu button
	jQuery('#northern-lights').on('click tap', function() {
		( document.stage.northern_lights ) ? turnNorthernLightsOff() : turnNorthernLightsOn();
    });



	function daytime() {
		jQuery('.scenery__container__background__night-time, .scenery__container__background__evening-time').fadeOut(6000);
		jQuery('.scenery__container__background__day-time').fadeIn(6000);
		jQuery('.lightsContainer canvas').remove();
		jQuery('.object-manipulation-toolbar__button__description, .object-manipulation-toolbar__inner__and__mobile__menu_hamburger-button, .object-manipulation-toolbar__button__bring-forward, .object-manipulation-toolbar__button__send-back, .object-manipulation-toolbar__button__rotate, .object-manipulation-toolbar__button__undo, .object-manipulation-toolbar__button__delete').removeClass('night-time');
	}
	function eveningtime() {
		jQuery('.scenery__container__background__day-time, .scenery__container__background__night-time').fadeOut(6000);
		jQuery('.scenery__container__background__evening-time').fadeIn(6000);
		jQuery('.lightsContainer canvas').remove();
		jQuery('.object-manipulation-toolbar__button__description, .object-manipulation-toolbar__inner__and__mobile__menu_hamburger-button, .object-manipulation-toolbar__button__bring-forward, .object-manipulation-toolbar__button__send-back, .object-manipulation-toolbar__button__rotate, .object-manipulation-toolbar__button__undo, .object-manipulation-toolbar__button__delete').removeClass('night-time');
	}
	function nighttime() {
		jQuery('.scenery__container__background__day-time, .scenery__container__background__evening-time').fadeOut(6000);
		jQuery('.scenery__container__background__night-time').fadeIn(6000);
		jQuery('.object-manipulation-toolbar__button__description, .object-manipulation-toolbar__inner__and__mobile__menu_hamburger-button, .object-manipulation-toolbar__button__bring-forward, .object-manipulation-toolbar__button__send-back, .object-manipulation-toolbar__button__rotate, .object-manipulation-toolbar__button__undo, .object-manipulation-toolbar__button__delete').addClass('night-time');
	}
	nighttime();


    /**
	 * The possible UI states
	 */
	var states = {
		// Alias for edit
		index: function( app ) { this.edit( app ); },
		gallery: function(app) {
			var body = document.querySelector('body');
			var container = document.querySelector('.container');
			var gallery = document.querySelector('#gallery');

        body.classList.remove('snowing');
        gallery.classList.remove('hidden');
        container.style.display = 'none';
		},
		/**
		 * The edit UI state shows the edit toolbars and the stage is put in
		 * edit state.
		 */
		edit: function( app ) {
			app.action = 'edit';  // Keep app object current
			jQuery('body').addClass('build');

      // if ( ! app.loaded ) { document.stage.load(); }

			// Put stage in edit mode
			document.stage.edit();

			showIntro(function() {
				showMountainAnimation();
				showEditToolbars();  // Edit toolbar for editting the snowman
				hideFunctionsToolbar();  // Function buttons for saving/sharing/editing

			});

			window.history.pushState( { app: app, url: document.stage.url.edit }, "Build Your Snowman Card", document.stage.url.edit );
		},

		/**
		 * The edit UI state shows the functions toolbars and the stage is put
		 * in preview state.
		 */
		preview: function( app ) {
			app.action = 'preview';  // Keep app object current

            // Load snowman
			// if ( ! app.loaded ) { document.stage.load(); }

			document.stage.preview();  // Don't allow edits
			document.stage.selectItem( null );  // Make sure nothing is selected.

			hideIntro();
			showMountainAnimation();
			hideEditToolbars();
			showFunctionsToolbar();  // Function buttons for saving/sharing/editing

			window.history.pushState( { app: app, url: document.stage.url.preview }, "Preview Your Snowman Card", document.stage.url.preview );
		},

		/**
		 * The image UI state shows the image alone.
		 */
		image: function( app ) {
			app.action = 'image';  // Keep app object current
			jQuery( 'body' ).addClass( 'image' );

			hideIntro();

            // Draw (not load) snowman
			if ( app.data && app.data != '' ) { document.stage.draw( app.data ); }
			document.stage.selectItem( null );  // Make sure nothing is selected.
		},

		/**
		 * The card UI state shows the image and the build your own button.
		 */
		card: function( app ) {
			app.action = 'card';  // Keep app object current

            // Load snowman
			document.stage.clear();
			document.stage.load();

			document.stage.preview();  // Don't allow edits
			document.stage.selectItem( null );  // Make sure nothing is selected.

			jQuery("#ui__build-toolbar__buttons").removeClass('hide');

			hideIntro();
			showMountainAnimation();
			hideFunctionsToolbar();
			hideEditToolbars();  // MUST be after hideFunctionsToolbar() to hide preview/save/share buttons

			window.history.pushState( { app: app, url: document.stage.url.card }, "Your Snowman Card", document.stage.url.card );
		},
	};

	/**
	 * Helper function to load a state
	 *
	 * @param string - the state to load
	 * @param app - expects the app object
	 */
	function loadState( state, app ) {
		app = app || window['app'];  // Use global app if no args are given
		state = state || app.action;
		if (typeof states[state] !== 'function') {
			state= 'gallery'
		}
		return states[state]( app );
	}

	/**
	 * Helper function to load a state
	 *
	 * @param app - expects the app object (should have a state property that
	 * 				is one of the states functions)
	 */
	function load( app ) { return states[app.action]( app ); }

	/**
	 * Event handler for popstates.
	 */
	if ( app.action !== 'image' ) {
		window.onpopstate = function( event ) { load( event.state.app ) };
	}

	loadState(); // Load initial state


	/* Mountain stuff. */

	/* var RightOffset = jQuery(window).width() - ( jQuery(".scenery__container__foregound__mountains__right-peak").offset().left + jQuery(".scenery__container__foregound__mountains__right-peak").width() );

	if ( RightOffset >= 0 ) {
		jQuery(".scenery__container__foregound__mountains__right-peak").css({ 'right' : '0px', 'left' : 'auto' });
	}

	var LeftOffset = jQuery(".scenery__container__foregound__mountains__right-peak").offset().left;

	if ( LeftOffset && LeftOffset < 0 ) {
		console.log('Trigger: '+ LeftOffset);
		// jQuery(".scenery__container__foregound__mountains__right-peak").css({ 'left' : '0px', 'right' : 'auto' });
		jQuery(".scenery__container__foregound__mountains__right-peak").css({ 'right' : '0px', 'left' : 'auto' });

	} */

/* 	jQuery( window ).resize(function() {
		RightOffset = jQuery(window).width() - ( jQuery(".scenery__container__foregound__mountains__right-peak").offset().left + jQuery(".scenery__container__foregound__mountains__right-peak").width() );

		if ( RightOffset >= 0 ) {
			jQuery(".scenery__container__foregound__mountains__right-peak").css({ 'right' : '0px', 'left' : 'auto' });
		}

		LeftOffset = jQuery(".scenery__container__foregound__mountains__right-peak").offset().left;

		if ( LeftOffset && LeftOffset < 0 ) {
			console.log('Trigger: '+ LeftOffset);
			// jQuery(".scenery__container__foregound__mountains__right-peak").css({ 'left' : '0px', 'right' : 'auto' });
			jQuery(".scenery__container__foregound__mountains__right-peak").css({ 'right' : '0px', 'left' : 'auto' });

		}
	}); */



	/* Begin animation JS */



	/*
	jQuery( "body" ).on( "click", function() {
		YettiThrow();
		console.log('toss');
	});
	*/

});

/**
var folder = "images/";

$.ajax({
    url : "scenery",
    success: function (data) {
        $(data).find("a").attr("href", function (i, val) {
            if( val.match(/\.(jpe?g|png|gif)$/) ) {
                $("body").append( "<img src='"+ folder + val +"'>" );
            }
        });
    }
});
*/
